import React, { useEffect, useState, createElement } from 'react';
import { Link } from 'react-router-dom';
import { Search, TrendingUp, TrendingDown, Sparkles, LineChart, ArrowUpRight, ChevronRight, Shield, Leaf, FileText, Activity, CheckCircle2, ChevronLeft, AlertCircle, Network } from 'lucide-react';
import { AppCard } from '../components/base/AppCard';
import { AppBadge } from '../components/base/AppBadge';
import { MiniSparkline } from '../components/charts/MiniSparkline';
import { useScreenInit } from '../useScreenInit.js';
const SLIDES = [{
  id: 1,
  badge: 'Azione richiesta',
  title: '1 Anomalia Rilevata',
  desc: 'Il servizio Customer Assistant sta generando costi superiori alla media.',
  btnText: 'Verifica anomalia',
  icon: Activity,
  colorClass: 'bg-red-500/80',
  bgGlow: 'bg-red-500/10'
}, {
  id: 2,
  badge: 'Suggerimento',
  title: 'Nuovo Modello',
  desc: 'Passa a GPT-4o-mini per risparmiare il 40% sui costi di inferenza.',
  btnText: 'Scopri di più',
  icon: Sparkles,
  colorClass: 'bg-[#00B4D8]/80',
  bgGlow: 'bg-[#00B4D8]/10'
}, {
  id: 3,
  badge: 'Compliance',
  title: 'Update AI Act',
  desc: 'Nuove linee guida disponibili per la classificazione del rischio dei modelli.',
  btnText: 'Leggi policy',
  icon: Shield,
  colorClass: 'bg-amber-500/80',
  bgGlow: 'bg-amber-500/10'
}];
export function CostManagementPage() {
  const screenInit = useScreenInit();
  const [activeTab, setActiveTab] = useState(screenInit.activeTab ?? 'In evidenza');
  const [expandedCard, setExpandedCard] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % SLIDES.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  return <div className="min-h-screen bg-[#F4F6F8] p-4 md:p-8" data-id="element-2470" data-mp="2v82579qo15n4">
      {/* Header Section */}
      <div className="flex flex-col lg:flex-row justify-between items-stretch gap-8 mb-10" data-id="element-2471" data-mp="15vguwqwi57a6">
        <div className="flex-1 flex flex-col justify-center" data-id="element-2472" data-mp="10xyk0uyxchzj">
          <h1 className="md:text-[32px] text-[#1A202C] tracking-tight mb-3 text-[28px] font-[600]" data-id="element-2473" data-mp="1ql1bdsb4ka13">
            Ciao, Marco!
            <br data-id="element-2474" data-mp="1umd2k29nd3be" />
            Ecco il riepilogo della tua infrastruttura AI.
          </h1>
          <p className="text-[14px] text-gray-600 max-w-2xl mb-5 leading-relaxed" data-id="element-2475" data-mp="1zk67yt34ltam">
            I costi mostrano un picco insolito, mentre compliance e
            sostenibilità sono nella norma.
          </p>
          <div className="flex flex-wrap items-center gap-3 mb-6" data-id="element-2476" data-mp="29ilzgx62f4kn">
            <div className="flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-200 rounded-lg shadow-sm" data-id="element-2477" data-mp="2djxhagip6lia">
              <Activity className="w-4 h-4 text-[#00B4D8]" data-id="element-2478" data-mp="2icqln3a97rtu" />
              <span className="text-[13px] font-medium text-gray-700" data-id="element-2479" data-mp="2na8vqx00cd3f">
                12 Servizi Monitorati
              </span>
            </div>
            <div className="flex items-center gap-2 px-3 py-1.5 bg-red-50 border border-red-100 rounded-lg shadow-sm" data-id="element-2480" data-mp="2sb6d57d7133v">
              <AlertCircle className="w-4 h-4 text-red-500" data-id="element-2481" data-mp="2x6lqly7agwzr" />
              <span className="text-[13px] font-medium text-red-700" data-id="element-2482" data-mp="lme1zznk06r4">
                1 Richiede Attenzione
              </span>
            </div>
            <Link to="/canvas" className="flex items-center gap-2 px-3 py-1.5 bg-[#2A3B5C] text-white rounded-lg shadow-sm hover:bg-[#1E2A40] transition-colors" data-id="element-2483" data-mp="gomcfcadswq3">
              <Network className="w-4 h-4" data-id="element-2484" data-mp="6pdkeoz2ts6d" />
              <span className="text-[13px] font-medium" data-id="element-2485" data-mp="14buhbt3we3rl">Vai alla Mappa AI</span>
              <ArrowUpRight className="w-3 h-3 opacity-70" data-id="element-2486" data-mp="14dx4m5do1ism" />
            </Link>
          </div>
        </div>

        {/* Status Slider Card */}
        <div className="relative w-full lg:w-[420px] min-h-[200px] rounded-2xl bg-gradient-to-br from-[#2A3B5C] to-[#1E2A40] border border-[#2A3B5C]/20 overflow-hidden flex flex-col p-6 shrink-0 shadow-lg group" data-id="element-2487" data-mp="ulj57ja28o9m">
          {/* Abstract decorative shapes - Dynamic based on slide */}
          <div className={`absolute top-[-20%] right-[-10%] w-48 h-48 rounded-full blur-3xl mix-blend-screen pointer-events-none transition-colors duration-1000 ${SLIDES[currentSlide].bgGlow}`} data-id="element-2488" data-mp="1ibvht7g9396j"></div>
          <div className={`absolute bottom-[-10%] left-[20%] w-40 h-40 rounded-full blur-3xl mix-blend-screen pointer-events-none transition-colors duration-1000 ${SLIDES[currentSlide].bgGlow}`} data-id="element-2489" data-mp="17sfajloncd3b"></div>

          <div className="relative z-10 flex-1 flex flex-col justify-between" data-id="element-2490" data-mp="xu9azaqbbj1m">
            <div className="flex items-center justify-between mb-2" data-id="element-2491" data-mp="xwc5a6yhzyc5">
              <span className="text-white/60 text-[12px] uppercase tracking-wider font-medium" data-id="element-2492" data-mp="1lkvgau8xmp7x">
                Notifiche di Sistema
              </span>
              <span className="flex items-center gap-1.5 text-white text-[12px] font-medium bg-white/10 px-2.5 py-1 rounded-full border border-white/20 backdrop-blur-md transition-all duration-500" data-id="element-2493" data-mp="1butte5sbfcul">
                {createElement(SLIDES[currentSlide].icon, {
                className: 'w-3.5 h-3.5'
              })}
                {SLIDES[currentSlide].badge}
              </span>
            </div>

            {/* Carousel Content */}
            <div className="mt-4 relative h-[70px] overflow-hidden" data-id="element-2494" data-mp="3tyigmp1r11yy">
              {SLIDES.map((slide, index) => <div key={slide.id} className={`absolute inset-0 transition-all duration-500 ease-in-out ${index === currentSlide ? 'opacity-100 translate-x-0' : index < currentSlide ? 'opacity-0 -translate-x-full' : 'opacity-0 translate-x-full'}`} data-id="element-2495" data-mp="3p0gutwcxuojs" data-mpi={index}>
                  <h2 className="text-white font-heading font-bold tracking-tight text-[28px]" data-id="element-2496" data-mp="3b0z6fi3k1day">
                    {slide.title}
                  </h2>
                  <p className="text-white/70 text-[13px] mt-1 max-w-[280px]" data-id="element-2497" data-mp="363yxmzfblwg5">
                    {slide.desc}
                  </p>
                </div>)}
            </div>

            {/* Bottom Section: Button & Pagination */}
            <div className="mt-6 flex items-center justify-between" data-id="element-2498" data-mp="zbodo6nn3amt">
              <button className="flex items-center gap-2 px-5 py-2.5 rounded-xl bg-white/10 backdrop-blur-md border border-white/20 text-white text-[13px] font-medium hover:bg-white/20 transition-colors shadow-lg" data-id="element-2499" data-mp="z9v5gmxdoicp">
                <span className={`flex items-center justify-center min-w-[20px] h-[20px] text-white rounded-full text-[11px] font-bold transition-colors duration-500 ${SLIDES[currentSlide].colorClass}`} data-id="element-2500" data-mp="3o6xmdzdxirhx">
                  {currentSlide + 1}
                </span>
                {SLIDES[currentSlide].btnText}
                <ArrowUpRight className="w-4 h-4 text-white/70 ml-1" data-id="element-2501" data-mp="35e2421h6rbwe" />
              </button>

              {/* Pagination Dots */}
              <div className="flex items-center gap-1.5" data-id="element-2502" data-mp="3acdf2fj7vsg7">
                {SLIDES.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`h-1.5 rounded-full transition-all duration-300 ${index === currentSlide ? 'w-4 bg-white' : 'w-1.5 bg-white/30 hover:bg-white/50'}`} data-id="element-2503" data-mp="3ee8d9b5upppr" data-mpi={index} />)}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs Section */}
      <div className="border-b-2 border-gray-300 mb-6" data-id="element-2504" data-mp="2qo4crcnym62z">
        <div className="-mb-[2px] flex items-center gap-8 overflow-x-auto custom-scrollbar" data-id="element-2505" data-mp="2j5o86euuqmtf">
          {['In evidenza', 'Per te', 'Tutti i servizi'].map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`pb-3 text-[16px] transition-colors whitespace-nowrap border-b-2 ${activeTab === tab ? 'border-[#00B4D8] text-[#2A3B5C]' : 'border-transparent text-gray-500 hover:text-gray-800'}`} data-id="element-2506" data-mp="2e7v2ro1dhwu7">
              {tab}
            </button>)}
        </div>
      </div>

      {/* Metric Cards Section - Netflix-style Accordion */}
      <div className="flex flex-col lg:flex-row gap-6 lg:h-[420px]" data-id="element-2507" data-mp="1vf109tkxrx6v">
        {/* Card 1: Gestione Costi */}
        <div onMouseEnter={() => setExpandedCard(0)} className={`bg-white border border-gray-200 rounded-2xl p-6 flex flex-col relative overflow-hidden cursor-pointer transition-all duration-500 ease-in-out shadow-sm hover:shadow-md ${expandedCard === 0 ? 'flex-[2]' : 'flex-1'}`} data-id="element-2508" data-mp="1qhsg5ng89j2z">
          <div className="flex items-start justify-between mb-4 relative z-10" data-id="element-2509" data-mp="1cgy5sz9md81o">
            <h3 className="text-[16px] font-semibold text-[#1A202C] whitespace-nowrap flex items-center gap-2" data-id="element-2510" data-mp="30e5rk5xpkvyw">
              <LineChart className="w-4 h-4 text-[#00B4D8]" data-id="element-2511" data-mp="35d8v1ly1iu4r" />
              Gestione Costi
            </h3>
            <AppBadge variant="default" className="bg-red-50 text-red-600 border border-red-100 shrink-0" data-id="element-2512" data-mp="2rc6713nhj9r7">
              Da verificare
            </AppBadge>
          </div>

          <div className="relative z-10" data-id="element-2513" data-mp="2hnoaiym8notd">
            <p className="font-heading font-bold text-[#1A202C] text-[28px]" data-id="element-2514" data-mp="2hlv2pfzw2yjs">
              € 2.435
            </p>
          </div>

          {/* Collapsed Preview */}
          <div className={`transition-all duration-500 ease-in-out overflow-hidden ${expandedCard === 0 ? 'max-h-0 opacity-0' : 'max-h-[100px] opacity-100'}`} data-id="element-2515" data-mp="28n9lbo65lpkl">
            <div className="pt-3" data-id="element-2516" data-mp="2clyybfna553p">
              <div className="flex items-center gap-1.5 text-[12px] text-red-600 font-medium mb-2" data-id="element-2517" data-mp="1yo0o8mfzruu0">
                <TrendingUp className="w-3.5 h-3.5" data-id="element-2518" data-mp="23nwpwf17va6e" /> +17% vs media
              </div>
              <div className="mb-2" data-id="element-2519" data-mp="1k1li8i5zu6y2">
                <MiniSparkline data={[10, 12, 15, 14, 20, 25, 30]} color="#ef4444" className="h-[24px]" data-id="element-2520" data-mp="1k2ms4jb9wne7" />
              </div>
              <p className="text-[12px] text-gray-500 leading-snug line-clamp-1" data-id="element-2521" data-mp="1f4v1dsmd77bl">
                Picco su Customer Assistant.
              </p>
            </div>
          </div>

          {/* Expanded Content */}
          <div className={`transition-all duration-500 ease-in-out flex flex-col ${expandedCard === 0 ? 'flex-1 max-h-[400px] mt-4' : 'max-h-0 mt-0'} overflow-hidden`} data-id="element-2522" data-mp="1p3arbs9noaji">
            <div className={`transition-opacity duration-500 ease-in-out flex flex-col flex-1 ${expandedCard === 0 ? 'opacity-100 delay-150' : 'opacity-0'}`} data-id="element-2523" data-mp="1y135uu7jze5u">
              {/* Custom Inline SVG Chart */}
              <div className="w-full h-[100px] mt-auto relative z-10 text-[#00B4D8] mb-4 shrink-0" data-id="element-2524" data-mp="27s7llw51z31q">
                <svg viewBox="0 0 400 120" className="w-full h-full overflow-visible" preserveAspectRatio="none" data-id="element-2525" data-mp="2lrgqw0rq0cqx">
                  {/* Background faded bars */}
                  <g opacity="0.1" fill="currentColor" data-id="element-2526" data-mp="xo6htri225ey">
                    {Array.from({
                    length: 40
                  }).map((_, i) => {
                    const height = 40 + Math.sin(i * 0.3) * 10 + (i > 30 ? (i - 30) * 4 : 0);
                    return <rect key={i} x={i * 10} y={120 - height} width="6" height={height} rx="2" data-id="element-2527" data-mp="iy8pczd3etjy" data-mpi={i} />;
                  })}
                  </g>

                  <line x1="300" y1="10" x2="300" y2="120" stroke="#CBD5E0" strokeWidth="1" strokeDasharray="4 4" data-id="element-2528" data-mp="1gkxyrua4k8fu" />

                  <path d="M 0 90 Q 50 100, 100 80 T 200 95 T 300 85 L 390 30" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-2529" data-mp="1bnfn3w4q3f45" />

                  <text x="0" y="75" fill="#718096" fontSize="12" fontWeight="500" data-id="element-2530" data-mp="12l6cl69gflqr">
                    1.3K
                  </text>
                  <text x="365" y="20" fill="#718096" fontSize="12" fontWeight="500" data-id="element-2531" data-mp="3rfd9ne0vdcs4">
                    1.6K
                  </text>
                </svg>
              </div>

              <p className="text-[13px] text-gray-600 leading-relaxed mb-4" data-id="element-2532" data-mp="22vphx3kwd5ft">
                Picco di spesa rilevato nel servizio Customer Assistant (+17%
                rispetto alla media).
              </p>

              <div className="flex flex-col gap-2 mt-auto" data-id="element-2533" data-mp="2btjgkl64wb65">
                <button className="w-full flex items-center justify-center px-6 py-3 bg-[#2A3B5C] text-white rounded-md hover:bg-[#1E2A40] transition-colors" data-id="element-2534" data-mp="2gmcf2rb0en9s">
                  <span className="text-[15px] font-heading uppercase tracking-wide whitespace-nowrap" data-id="element-2535" data-mp="2ln8lbbiu2lid">
                    Analisi Dettagliata
                  </span>
                </button>
                <button className="w-full flex items-center justify-center px-6 py-3 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors" data-id="element-2536" data-mp="2ujhj6lr5xc2e">
                  <span className="text-[15px] font-heading uppercase tracking-wide whitespace-nowrap" data-id="element-2537" data-mp="108mc5nvmm51q">
                    Ottimizza Costi
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Card 2: Compliance */}
        <div onMouseEnter={() => setExpandedCard(1)} className={`bg-white border border-gray-200 rounded-2xl p-6 flex flex-col cursor-pointer overflow-hidden transition-all duration-500 ease-in-out shadow-sm hover:shadow-md ${expandedCard === 1 ? 'flex-[2]' : 'flex-1'}`} data-id="element-2538" data-mp="23j8ma9b197zx">
          <div className="flex items-start justify-between mb-4" data-id="element-2539" data-mp="2rg5w1vl3z3kh">
            <h3 className="text-[16px] font-semibold text-[#1A202C] whitespace-nowrap flex items-center gap-2" data-id="element-2540" data-mp="2rekxzvzl52hv">
              <Shield className="w-4 h-4 text-[#00B4D8]" data-id="element-2541" data-mp="2mfi5fb0skoqs" />
              Compliance
            </h3>
            <AppBadge variant="default" className="bg-emerald-50 text-emerald-600 border border-emerald-100 shrink-0" data-id="element-2542" data-mp="30ak71lylvrxs">
              Conforme
            </AppBadge>
          </div>

          <div data-id="element-2543" data-mp="3a76ri9n0sgza">
            <p className="font-heading font-bold text-[#1A202C] text-[28px]" data-id="element-2544" data-mp="3a4kjya04q1h2">
              98%
            </p>
          </div>

          {/* Collapsed Preview */}
          <div className={`transition-all duration-500 ease-in-out overflow-hidden ${expandedCard === 1 ? 'max-h-0 opacity-0' : 'max-h-[100px] opacity-100'}`} data-id="element-2545" data-mp="3ouxan4ccsoz0">
            <div className="pt-3 flex flex-col gap-2" data-id="element-2546" data-mp="3evy35p3bqzdl">
              <div className="w-full bg-gray-100 rounded-full h-1.5 mb-1" data-id="element-2547" data-mp="3ev6fd0fyy5xv">
                <div className="bg-emerald-500 h-1.5 rounded-full" style={{
                width: '98%'
              }} data-id="element-2548" data-mp="3jt7zlop4sbax"></div>
              </div>
              <span className="text-[12px] text-gray-600 flex items-center gap-1.5" data-id="element-2549" data-mp="3atuo6qhg5cnk">
                <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500" data-id="element-2550" data-mp="3avnxyencwczs" /> 0
                violazioni
              </span>
              <span className="text-[12px] text-gray-600 flex items-center gap-1.5" data-id="element-2551" data-mp="313ryp09jagtz">
                <Shield className="w-3.5 h-3.5 text-emerald-500" data-id="element-2552" data-mp="2n48rc9ojr9iq" /> Rischio
                Basso
              </span>
            </div>
          </div>

          {/* Expanded Content */}
          <div className={`transition-all duration-500 ease-in-out flex flex-col ${expandedCard === 1 ? 'flex-1 max-h-[400px] mt-4' : 'max-h-0 mt-0'} overflow-hidden`} data-id="element-2553" data-mp="2r7yb8lua12xf">
            <div className={`transition-opacity duration-500 ease-in-out flex flex-col flex-1 ${expandedCard === 1 ? 'opacity-100 delay-150' : 'opacity-0'}`} data-id="element-2554" data-mp="2f4votxuf6v9i">
              <div className="flex flex-wrap gap-2 mb-4" data-id="element-2555" data-mp="25e1633gdudst">
                <span className="text-[11px] text-gray-600 flex items-center gap-1 bg-gray-100 px-2.5 py-1 rounded-full w-fit font-medium" data-id="element-2556" data-mp="25dhmzjezxjd7">
                  <CheckCircle2 className="w-3 h-3 text-emerald-500" data-id="element-2557" data-mp="1wcjpzl2z6c44" /> 0
                  violazioni critiche
                </span>
                <span className="text-[11px] text-gray-600 flex items-center gap-1 bg-gray-100 px-2.5 py-1 rounded-full w-fit font-medium" data-id="element-2558" data-mp="1rerobzcj3bmq">
                  <CheckCircle2 className="w-3 h-3 text-emerald-500" data-id="element-2559" data-mp="1mh9ocygho6qv" /> 100% log
                  conservati
                </span>
                <span className="text-[11px] text-gray-600 flex items-center gap-1 bg-gray-100 px-2.5 py-1 rounded-full w-fit font-medium" data-id="element-2560" data-mp="3gsejtfhf9cv4">
                  <Shield className="w-3 h-3 text-emerald-500" data-id="element-2561" data-mp="3p9op9km6vrcz" /> Rischio AI
                  Act: Basso
                </span>
              </div>

              <p className="text-[13px] text-gray-600 leading-relaxed mb-4" data-id="element-2562" data-mp="1x4fle8s20er">
                Tutti i servizi operativi rispettano i requisiti normativi.
                Ultimo audit superato con successo.
              </p>

              <div className="flex flex-col gap-2 mt-auto" data-id="element-2563" data-mp="36c4cvd0m2l99">
                <button className="w-full flex items-center justify-center px-6 py-3 bg-[#2A3B5C] text-white rounded-md hover:bg-[#1E2A40] transition-colors" data-id="element-2564" data-mp="3aco98edd1kuc">
                  <span className="text-[15px] font-heading uppercase tracking-wide whitespace-nowrap" data-id="element-2565" data-mp="3fa69lgdbarqq">
                    Vedi Audit Trail
                  </span>
                </button>
                <button className="w-full flex items-center justify-center px-6 py-3 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors" data-id="element-2566" data-mp="ukqlit5h9h4s">
                  <span className="text-[15px] font-heading uppercase tracking-wide whitespace-nowrap" data-id="element-2567" data-mp="9w7mcdygrx41">
                    Report AI Act
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Card 3: GreenOps */}
        <div onMouseEnter={() => setExpandedCard(2)} className={`bg-white border border-gray-200 rounded-2xl p-6 flex flex-col cursor-pointer overflow-hidden transition-all duration-500 ease-in-out shadow-sm hover:shadow-md ${expandedCard === 2 ? 'flex-[2]' : 'flex-1'}`} data-id="element-2568" data-mp="evkfthjuc2fl">
          <div className="flex items-start justify-between mb-4" data-id="element-2569" data-mp="3ia6d916kwsao">
            <h3 className="text-[16px] font-semibold text-[#1A202C] whitespace-nowrap flex items-center gap-2" data-id="element-2570" data-mp="wugrwdgnsol">
              <Leaf className="w-4 h-4 text-[#00B4D8]" data-id="element-2571" data-mp="3s8vxv1pv0qum" />
              GreenOps
            </h3>
            <AppBadge variant="default" className="bg-emerald-50 text-emerald-600 border border-emerald-100 shrink-0" data-id="element-2572" data-mp="34jl1rxjgfkmt">
              Ottimizzato
            </AppBadge>
          </div>

          <div data-id="element-2573" data-mp="1f2pj67qj7exq">
            <p className="font-heading font-bold text-[#1A202C] text-[28px]" data-id="element-2574" data-mp="1f262eucmawla">
              124 kg CO₂
            </p>
          </div>

          {/* Collapsed Preview */}
          <div className={`transition-all duration-500 ease-in-out overflow-hidden ${expandedCard === 2 ? 'max-h-0 opacity-0' : 'max-h-[100px] opacity-100'}`} data-id="element-2575" data-mp="156chonoqvwsf">
            <div className="pt-3" data-id="element-2576" data-mp="1a2b8ehxjpqw0">
              <div className="flex items-center gap-1.5 text-[12px] text-emerald-600 font-medium mb-2" data-id="element-2577" data-mp="1xtytukc1g9qw">
                <TrendingDown className="w-3.5 h-3.5" data-id="element-2578" data-mp="22tl5ipc7xhxl" /> -15% vs mese scorso
              </div>
              <div className="mb-2" data-id="element-2579" data-mp="1oubq3rvu6ruo">
                <MiniSparkline data={[30, 28, 25, 22, 18, 15, 12]} color="#10b981" className="h-[24px]" data-id="element-2580" data-mp="1otahrv67gjgn" />
              </div>
              <p className="text-[12px] text-gray-500 leading-snug line-clamp-1" data-id="element-2581" data-mp="deer1auaarjq">
                Routing dinamico SLM attivo.
              </p>
            </div>
          </div>

          {/* Expanded Content */}
          <div className={`transition-all duration-500 ease-in-out flex flex-col ${expandedCard === 2 ? 'flex-1 max-h-[400px] mt-4' : 'max-h-0 mt-0'} overflow-hidden`} data-id="element-2582" data-mp="193bhz5rewxpw">
            <div className={`transition-opacity duration-500 ease-in-out flex flex-col flex-1 ${expandedCard === 2 ? 'opacity-100 delay-150' : 'opacity-0'}`} data-id="element-2583" data-mp="146l3gmv9aa6l">
              <div className="mb-4" data-id="element-2584" data-mp="v4tw7dl2hvam">
                <span className="text-[12px] text-emerald-700 flex items-center gap-1 bg-emerald-50 border border-emerald-100 px-2.5 py-1 rounded-full w-fit font-medium" data-id="element-2585" data-mp="v5vars1akzx3">
                  <TrendingDown className="w-3 h-3" data-id="element-2586" data-mp="1ntr5wsb7qjrr" /> -15% vs mese scorso
                </span>
              </div>

              <p className="text-[13px] text-gray-600 leading-relaxed mb-4" data-id="element-2587" data-mp="1izwo5uf64evb">
                Risparmiati 45 kg di CO₂ questo mese grazie al routing dinamico
                verso modelli più efficienti (SLM).
              </p>

              <div className="flex flex-col gap-2 mt-auto" data-id="element-2588" data-mp="26rbudya2fgbu">
                <button className="w-full flex items-center justify-center px-6 py-3 bg-[#2A3B5C] text-white rounded-md hover:bg-[#1E2A40] transition-colors" data-id="element-2589" data-mp="26pr089rnxzei">
                  <span className="text-[15px] font-heading uppercase tracking-wide whitespace-nowrap" data-id="element-2590" data-mp="2j11g18anoulo">
                    Dettaglio Emissioni
                  </span>
                </button>
                <button className="w-full flex items-center justify-center px-6 py-3 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors" data-id="element-2591" data-mp="2s2r5w9ow3lhc">
                  <span className="text-[15px] font-heading uppercase tracking-wide whitespace-nowrap" data-id="element-2592" data-mp="2wz87a5l3nwcd">
                    Suggerimenti Eco
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}